<template>
    <div class="absolute w-full left-0 z-0">
        <div class="relative w-full aspect-w-1 aspect-h-1 overflow-hidden">
            <div>
                <div class="container relative h-full">
                    <div
                        class="bg absolute w-[200%] h-[150%] xl:w-[200%] xl:h-[100%] left-[50%] bg-contain bg-no-repeat"
                        :class="{ 'flip-y': flipY, 'flip-x': flipX }"
                        :style="`background-position: top center; background-image: url(${require('assets/images/shapes/shape-5_yellow-400.png')})`"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopLocationBackgroundShape4',
    props: {
        flipY: {
            type: Boolean,
            required: false,
            default: false,
        },
        flipX: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
};
</script>

<style scoped>
.bg {
    transform: translateX(-50%);
    &.flip-y {
        bottom: 0;
        transform: translateX(-50%) rotateX(180deg);
    }
    &.flip-x {
        transform: translateX(-50%) rotateY(180deg);
    }

    &.flip-y.flip-x {
        transform: translateX(-50%) rotateX(180deg) rotateY(180deg);
    }
}
</style>
